import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { useStore } from "store";

import { Flex, Layout, Menu, Space } from "antd";
const { Sider } = Layout;

import {
  FileProtectOutlined,
  SafetyCertificateOutlined,
  BellOutlined,
  DollarOutlined,
  ClockCircleOutlined,
  GiftFilled,
  TeamOutlined,
  SecurityScanOutlined,
  UserOutlined,
  IdcardOutlined,
  FileSyncOutlined,
} from "@ant-design/icons";

import strings from "resources/strings";
import FooterContent from "components/Shared/FooterContent";

import { StatusIcon } from "../../../routes/Certificates/components";
import FeatureTag from "components/Shared/FeatureTag";

import "./style.scss";
const styleWrapperClass = "sidebar__";

export default function SideBar({ isDrawer, siderWidth, setDrawerOpen }) {
  let location = useLocation();

  const user = useStore((state) => state.user);
  const activeRfc = useStore((state) => state.activeRfc);

  const active_rfc_obj =
    activeRfc !== "nuevo-rfc" ? user.rfcs[activeRfc] : null;

  const navigate = useNavigate();

  const [selectedMenuItem, setSelectedMenuItem] = useState(
    location.pathname === "/" ? "/cfdis" : location.pathname,
  );

  useEffect(() => {
    if (location) {
      if (location.pathname.startsWith("/cfdis/")) {
        //Account for paths with an id_cfdi param
        setSelectedMenuItem("/cfdis");
      } else if (selectedMenuItem !== location.pathname) {
        setSelectedMenuItem(location.pathname);
      }
    }
  }, [location, selectedMenuItem]);

  const handleMenuClick = (item) => {
    setSelectedMenuItem(item.key);
    navigate(item.key);
    if (isDrawer) {
      setDrawerOpen(false);
    }
  };

  //Sidebar menu items
  const sidebarMenuItems =
    location.pathname === "/cuenta"
      ? [
          {
            key: "/cuenta",
            icon: <UserOutlined />,
            label: "Cuenta",
          },
        ]
      : location.pathname.startsWith("/admin")
        ? [
            {
              key: "/admin/rfcs",
              icon: <TeamOutlined />,
              label: "RFCs",
            },
          ]
        : [
            {
              key: "/cfdis",
              icon: <FileProtectOutlined />,
              label: "CFDIs",
              disabled: !!!active_rfc_obj,
            },
            // {
            //   key: "/reportes",
            //   icon: <FileSyncOutlined />,
            //   label: (
            //     <Flex align="center" gap={5}>
            //       Reportes
            //       <FeatureTag
            //         type={"new_feature"}
            //         cursor={"pointer"}
            //         useDarkBackground
            //       />
            //     </Flex>
            //   ),
            //   disabled: !!!active_rfc_obj,
            // },
            {
              key: "/perfil",
              icon: <IdcardOutlined />,
              label: (
                <Flex align="center" gap={5}>
                  Perfil Fiscal
                </Flex>
              ),
              disabled: !!!active_rfc_obj,
            },
            {
              key: "/efos",
              icon: <SecurityScanOutlined />,
              label: "EFOS",
              disabled: !!!active_rfc_obj,
            },
            {
              key: "/certificados",
              icon: <SafetyCertificateOutlined />,
              label: (
                <Space>
                  Certificados
                  <StatusIcon
                    rfcObj={active_rfc_obj}
                    showOk={false}
                    showTooltip={false}
                  />
                </Space>
              ),
            },
            {
              key: "/alertas",
              icon: <BellOutlined />,
              label: "Alertas",
              disabled: !!!active_rfc_obj,
            },
            {
              key: "/plan",
              icon: <DollarOutlined />,
              label: (
                <Space>
                  Plan
                  {active_rfc_obj?.plan_name !== "free" &&
                    user.stripe.subscription?.cancel_at && (
                      <ClockCircleOutlined style={{ color: "#C18622" }} />
                    )}
                  {active_rfc_obj?.plan_name === "free" &&
                    active_rfc_obj.has_eligible_trial && (
                      <GiftFilled style={{ color: "purple" }} />
                    )}
                </Space>
              ),
              disabled: !!!active_rfc_obj,
            },
          ];

  const sidebarContent = (
    <>
      <Flex align="center" vertical gap={30}>
        <img
          src={strings.url_logo_colored_svg}
          alt={strings.appName}
          style={{
            width: "50%",
            marginTop: isDrawer ? "-20px" : "30px",
          }}
        />
        <Menu
          mode="inline"
          selectedKeys={[selectedMenuItem]}
          items={sidebarMenuItems}
          onClick={handleMenuClick}
          style={{
            marginLeft: isDrawer ? "-40px" : null,
          }}
        />
      </Flex>
      <FooterContent />
    </>
  );

  return (
    <div className={styleWrapperClass}>
      {isDrawer ? (
        sidebarContent
      ) : (
        <Sider width={siderWidth}>{sidebarContent}</Sider>
      )}
    </div>
  );
}
